import React from "react";
import NewsTop from "../components/JSX/NewsTop";
import NewsPost from "../components/JSX/NewsPost";
import NewsLetter from "../components/JSX/NewsLetter";
import Nnavbar from "../components/JSX/Nnavbar";
import Footernews2 from "../components/JSX/Footernews2";

const NewsBlogs = () => {
  return (
    <>
      <Nnavbar/>
      <NewsTop />
      <NewsPost />
      <NewsLetter />
      <Footernews2/>

    </>
  );
};


export default NewsBlogs;
